import axios from "axios";
import saveAs from 'file-saver';
import i18n from '@/i18n';
import {alert} from '@pnotify/core';
import catchDispatch from "@/utils/catchDispatch";

export let exportTasksModal = {};

export default function onMessageDump({body: {short_hash, filename}, meta} = {}) {
  const modalProgress = exportTasksModal[meta.id];
  if (!modalProgress) return;

  const progressBar = modalProgress.refs.elem.querySelector('div.progress-bar');

  axios
    .get(`/drive/api/v1/files/documents/${short_hash}/${filename}`, {
      params: {alt: 'media'},
      responseType: 'blob',
      onDownloadProgress: ({loaded, total}) => {
        const progress = Math.round((loaded / total) * 100);

        progressBar.style.width = progress + '%'
        progressBar.setAttribute('aria-valuenow', progress);
      },
    })
    .then(({data}) => {
      (function (t, f, m) {
        try {
          saveAs.saveAs(new Blob([t], {type: m}), f);
        } catch (e) {
          window.open('data:' + m + ',' + encodeURIComponent(t), '_blank', '');
        }
      })(data, filename, 'text/csv');

      modalProgress.close();

      alert({
        title: i18n.t('rooms.dump.alert.end.title'),
        text: i18n.t('rooms.dump.alert.end.description'),
        addClass: 'bg-success text-white',
      });
    })
    .catch((e) => {
      modalProgress.close();
      catchDispatch.call(this, e);
    });
}
